import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Parameter } from '../../../_models/parameter';

import { Translation } from '../../../_languages/translations';


@Component({
  selector: 'app-parameter',
  templateUrl: './parameter-list.component.html'
})
export class ParameterListComponent implements OnInit, OnChanges {

  // Para el control del diccionario de traducción.
  tr: {};

  setTimeout_aux: number;

  title: string;
  subtitle: string;

  deleteModal: boolean;
  parameterForm: FormGroup;

  @Input() parameters: Parameter[];
  @Input() currentParameter: Parameter;
  @Output() selectParameter = new EventEmitter<Parameter>();

  constructor(
    public router: Router,
    private formBuilder: FormBuilder,
    public trans: Translation
  ) {}

  isOnOffParameter(parameterIn: Parameter | null): boolean {
    if (!parameterIn || !parameterIn.setup_key) {
      return false;
    }
    const key = parameterIn.setup_key.toString();
    return key === 'compact_exceptional_enabled' || key === 'sheet_plan_landscape_mode';
  }

  isPrintDimensionOrderParameter(parameterIn: Parameter | null): boolean {
    return !!parameterIn && parameterIn.setup_key === 'print_dimension_order';
  }

  private ensureParameterControl(parameterIn: Parameter): void {
    if (!parameterIn || !this.parameterForm) {
      return;
    }

    const controlName = 'parameterValue_' + parameterIn.id;
    let controlValue = parameterIn.setup_value !== null
      ? parameterIn.setup_value
      : (parameterIn.setup_value6 !== null ? parameterIn.setup_value6 : null);

    if (this.isOnOffParameter(parameterIn) || this.isPrintDimensionOrderParameter(parameterIn)) {
      controlValue = Number(controlValue) > 0 ? '1' : '0';
    }

    if (!this.parameterForm.contains(controlName)) {
      this.parameterForm.addControl(controlName, new FormControl(controlValue, Validators.required));
      return;
    }

    this.parameterForm.controls[controlName].setValue(controlValue);
  }

  private ensureParameterControls(parameterListIn: Parameter[]): void {
    if (!parameterListIn || !Array.isArray(parameterListIn) || !this.parameterForm) {
      return;
    }

    parameterListIn.forEach(item => this.ensureParameterControl(item));
  }

  ngOnChanges(changes: SimpleChanges) {

    console.log('->-> Entrando en ngOnChanges de parameter-list: ');
    console.log(changes);

    if (changes.parameters) {
      console.log('--> ngOnChanges parameter-list parameters:');
      console.log(changes.parameters.currentValue);

      this.ensureParameterControls(changes.parameters.currentValue);
    }
  } // End function ngOnChanges

  ngOnInit() {

    this.tr = this.trans.vocabulary;

    this.setTimeout_aux = 1500;
    this.title = this.tr['st2_title']; // 'Módulo de Parámetros';
    this.subtitle = this.tr['st2_subtitle']; // 'Listado de Parámetros';
    this.deleteModal = false;
    this.parameterForm = this.formBuilder.group({
      parameterValue_0: null,
      parameterValue_1: null,
      parameterValue_2: null,
      parameterValue_3: null,
      parameterValue_4: null,
      parameterValue_5: null,
      parameterValue_6: null,
      parameterValue_7: null,
      parameterValue_8: null,
      parameterValue_9: null,
      parameterValue_10: null,
      parameterValue_11: null,
      parameterValue_12: null,
      parameterValue_13: null,
      parameterValue_14: null,
      parameterValue_15: null,
      parameterValue_16: null,
      parameterValue_17: null,
      parameterValue_18: null,
      parameterValue_19: null,
      parameterValue_20: null,
      parameterValue_21: null,
      parameterValue_22: null,
      parameterValue_23: null,
      parameterValue_24: null,
      parameterValue_25: null,
      parameterValue_26: null,
      parameterValue_27: null,
      parameterValue_28: null,
      parameterValue_29: null,
      parameterValue_30: null,
      parameterValue_31: null,
      parameterValue_32: null,
      parameterValue_33: null,
      parameterValue_34: null,
      parameterValue_35: null,
      parameterValue_36: null,
      parameterValue_37: null,
      parameterValue_38: null,
      parameterValue_39: null,
      parameterValue_40: null,
      parameterValue_41: null,
      parameterValue_42: null,
      parameterValue_43: null,
      parameterValue_44: null,
      parameterValue_45: null,
      parameterValue_46: null,
      parameterValue_47: null,
      parameterValue_48: null,
      parameterValue_49: null,
      parameterValue_50: null,
      parameterValue_51: null,
      parameterValue_52: null,
      parameterValue_53: null,
      parameterValue_54: null,
      parameterValue_55: null,
      parameterValue_56: null,
      parameterValue_58: null,
      parameterValue_59: null,
      parameterValue_60: null,
      parameterValue_61: null,
      parameterValue_62: null,
      parameterValue_63: null,
      parameterValue_64: null,
      parameterValue_65: null,
      parameterValue_66: null,
      parameterValue_67: null,
      parameterValue_68: null,
      parameterValue_69: null,
      parameterValue_70: null
    });
    console.log('parameter-list.component.ts');
    this.ensureParameterControls(this.parameters);

  } // End function ngOnInit

  buttonUpdateParameter(parameter: Parameter | null) {
    console.log('-> -> Seleccionado Parámetro:');
    console.log(parameter);

    if (parameter.setup_value !== null) {
      // IMPORTANTE: Los campos de solapamiento y ancho de muela realmente hay que multiplicar el valor por 10.
      if (this.isOnOffParameter(parameter) || this.isPrintDimensionOrderParameter(parameter)) {
        parameter.setup_value = Number(this.parameterForm.controls['parameterValue_' + parameter.id].value) > 0 ? '1' : '0';
      } else if (parameter.setup_key === 'solapamiento' || parameter.setup_key === 'ancho_muela') {
        parameter.setup_value = (this.parameterForm.controls['parameterValue_' + parameter.id].value * 10).toString();
      } else {
        parameter.setup_value = this.parameterForm.controls['parameterValue_' + parameter.id].value;
      }

    } else if (parameter.setup_value === null && parameter.setup_value6 !== null) {
      parameter.setup_value6 = this.parameterForm.controls['parameterValue_' + parameter.id].value;
    } else {
      parameter.setup_value = this.parameterForm.controls['parameterValue_' + parameter.id].value;
    }

    this.selectParameter.emit(parameter);
  } // End function buttonSetCurrentParameter

  // En este caso se asegura de que sólo se muestren los usuarios cuya empresa es 'Dilaum'.
  filterGeneral(element: any): boolean {
    console.log('filterGeneral Item: ');
    console.log(element);

    if (element['setup_type'] === 'general') {
      return true;
    }
    return false;
  } // End function filterGeneral

} // End class ParameterListComponent
